'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ImageZoom = require('./ImageZoom');

var _ImageZoom2 = _interopRequireDefault(_ImageZoom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ImageZoom2.default;